/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

export function DetailedInventoryLedgerInfo({ formData }) {
  const { values, setFieldValue, containView } = formData;
  const { details = [] } = values;

  const handleChangeField = (path, val) => {
    setFieldValue(path, val);
  };

  const handleChangeTable = (index, field, val) => {
    const newDetails = [...details];
    newDetails[index][field] = val;

    // Auto calculate "Thành tiền" based on "Đơn giá" and "Số lượng" (if manually input unitPrice & Quantity)
    const unitP = parseFloat(newDetails[index].unitPrice) || 0;
    
    if (field === "unitPrice" || field === "inwardQuantity") {
      const inQty = parseFloat(newDetails[index].inwardQuantity) || 0;
      newDetails[index].inwardAmount = unitP * inQty;
    }
    
    if (field === "unitPrice" || field === "outwardQuantity") {
      const outQty = parseFloat(newDetails[index].outwardQuantity) || 0;
      newDetails[index].outwardAmount = unitP * outQty;
    }

    setFieldValue("details", newDetails);
  };

  // Tính Tồn Kho lũy kế tự động (Số lượng & Thành tiền)
  useEffect(() => {
    let runningQty = 0;
    let runningAmt = 0;

    const updatedDetails = details.map((row) => {
      const inQty = parseFloat(row.inwardQuantity) || 0;
      const outQty = parseFloat(row.outwardQuantity) || 0;
      const inAmt = parseFloat(row.inwardAmount) || 0;
      const outAmt = parseFloat(row.outwardAmount) || 0;

      // Cộng dồn
      runningQty = runningQty + inQty - outQty;
      runningAmt = runningAmt + inAmt - outAmt;

      return {
        ...row,
        balanceQuantity: runningQty,
        balanceAmount: runningAmt
      };
    });

    // Chỉ cập nhật nếu có sự thay đổi thực sự
    if (JSON.stringify(updatedDetails) !== JSON.stringify(details)) {
      setFieldValue("details", updatedDetails);
    }
  }, [JSON.stringify(details.map(d => ({ iQ: d.inwardQuantity, iA: d.inwardAmount, oQ: d.outwardQuantity, oA: d.outwardAmount })))]);

  const addRow = () => {
    const template = {
      docNumber: "",
      docDate: "",
      description: "",
      offsetAccount: "",
      unitPrice: 0,
      inwardQuantity: 0,
      inwardAmount: 0,
      outwardQuantity: 0,
      outwardAmount: 0,
      balanceQuantity: 0,
      balanceAmount: 0,
      note: ""
    };
    setFieldValue("details", [...details, template]);
  };

  const removeRow = (index) => {
    if (details.length <= 1) return;
    const newDetails = details.filter((_, i) => i !== index);
    setFieldValue("details", newDetails);
  };

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  const s = {
    container: { fontFamily: '"Times New Roman", Times, serif', color: "#000", padding: "20px", backgroundColor: "#fff", fontSize: "14px", lineHeight: "1.5" },
    headerTop: { display: "flex", justifyContent: "space-between", marginBottom: "15px" },
    titleBox: { textAlign: "center", margin: "10px 0" },
    inputDotted: { border: "none", borderBottom: "1px dotted #000", outline: "none", fontSize: "14px", fontFamily: "inherit", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    inputDottedSmall: { border: "none", borderBottom: "1px dotted #000", outline: "none", width: "40px", fontSize: "14px", fontFamily: "inherit", textAlign: "center", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    table: { width: "100%", borderCollapse: "collapse", fontSize: "12px", marginTop: "15px", marginBottom: "15px" },
    th: { border: "1px solid #000", padding: "6px 2px", textAlign: "center", fontWeight: "bold", verticalAlign: "middle", backgroundColor: "#fff" },
    td: { border: "1px solid #000", padding: 0, height: "35px", verticalAlign: "middle" },
    inputTable: { width: "100%", height: "100%", border: "none", outline: "none", padding: "0 4px", fontSize: "12px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableCenter: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "center", fontSize: "12px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableRight: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "right", padding: "0 4px", fontSize: "12px", fontFamily: "inherit", background: "transparent", color: "#000" },
    removeBtn: { border: "none", background: "transparent", color: "red", cursor: "pointer", fontWeight: "bold", fontSize: "16px" },
    rowLabel: { display: "flex", alignItems: "baseline", gap: "5px", marginBottom: "8px" }
  };

  return (
    <SoftBox style={s.container}>
      {/* HEADER */}
      <div style={s.headerTop}>
        <div style={{ width: "45%" }}>
          <div style={s.rowLabel}>Đơn vị: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.unit} onChange={(e) => handleChangeField("unit", e.target.value)} /></div>
          <div style={s.rowLabel}>Địa chỉ: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.address} onChange={(e) => handleChangeField("address", e.target.value)} /></div>
        </div>
        <div style={{ textAlign: "center", width: "55%" }}>
          <div style={{ fontWeight: "bold", fontSize: "16px" }}>Mẫu số S10-DN</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      {/* TITLE */}
      <div style={s.titleBox}>
        <h2 style={{ margin: 0, textTransform: "uppercase", fontSize: "18px" }}>SỔ CHI TIẾT VẬT LIỆU, DỤNG CỤ (SẢN PHẨM, HÀNG HÓA)</h2>
        <div style={{ marginTop: 10, fontWeight: "bold" }}>
          Năm: <input disabled={containView} style={{ ...s.inputDotted, width: "100px", textAlign: "center" }} value={values.year} onChange={(e) => handleChangeField("year", e.target.value)} />
        </div>
        <div style={{ marginTop: 5, fontWeight: "bold" }}>
          Tài khoản: <input disabled={containView} style={{ ...s.inputDotted, width: "100px", textAlign: "center" }} value={values.accountNumber} onChange={(e) => handleChangeField("accountNumber", e.target.value)} />
          &nbsp;&nbsp;Tên kho: <input disabled={containView} style={{ ...s.inputDotted, width: "200px", textAlign: "center" }} value={values.warehouseName} onChange={(e) => handleChangeField("warehouseName", e.target.value)} />
        </div>
      </div>

      {/* MATERIAL INFO */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginTop: "20px" }}>
        <div style={{ ...s.rowLabel, width: "70%" }}>
          Tên, quy cách nguyên liệu, vật liệu, công cụ, dụng cụ (sản phẩm, hàng hóa): 
          <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.itemName} onChange={(e) => handleChangeField("itemName", e.target.value)} />
        </div>
        <div style={{ ...s.rowLabel, width: "25%", justifyContent: "flex-end", fontStyle: "italic" }}>
          Đơn vị tính:
           <input disabled={containView} style={{ ...s.inputDotted, width: "100px", fontStyle: "normal" }} value={values.itemUnit} onChange={(e) => handleChangeField("itemUnit", e.target.value)} />
        </div>
      </div>

      {/* TABLE 12 COLUMNS */}
      <div style={{ overflowX: "auto" }}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={s.th} colSpan={2}>Chứng từ</th>
              <th style={{ ...s.th, width: "150px" }} rowSpan={2}>Diễn giải</th>
              <th style={{ ...s.th, width: "70px" }} rowSpan={2}>Tài khoản đối ứng</th>
              <th style={{ ...s.th, width: "80px" }} rowSpan={2}>Đơn giá</th>
              <th style={s.th} colSpan={2}>Nhập</th>
              <th style={s.th} colSpan={2}>Xuất</th>
              <th style={s.th} colSpan={2}>Tồn</th>
              <th style={{ ...s.th, width: "100px" }} rowSpan={2}>Ghi chú</th>
              {!containView && <th style={{ ...s.th, width: "40px" }} rowSpan={3}>#</th>}
            </tr>
            <tr>
              <th style={{ ...s.th, width: "70px" }}>Số hiệu</th>
              <th style={{ ...s.th, width: "80px" }}>Ngày, tháng</th>
              <th style={{ ...s.th, width: "60px" }}>Số lượng</th>
              <th style={{ ...s.th, width: "90px" }}>Thành tiền</th>
              <th style={{ ...s.th, width: "60px" }}>Số lượng</th>
              <th style={{ ...s.th, width: "90px" }}>Thành tiền</th>
              <th style={{ ...s.th, width: "60px" }}>Số lượng</th>
              <th style={{ ...s.th, width: "90px" }}>Thành tiền</th>
            </tr>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              <th style={s.th}>A</th>
              <th style={s.th}>B</th>
              <th style={s.th}>C</th>
              <th style={s.th}>D</th>
              <th style={s.th}>1</th>
              <th style={s.th}>2</th>
              <th style={s.th}>3=1x2</th>
              <th style={s.th}>4</th>
              <th style={s.th}>5=1x4</th>
              <th style={s.th}>6</th>
              <th style={s.th}>7=(1x6)</th>
              <th style={s.th}>8</th>
            </tr>
          </thead>
          <tbody>
            {(details || []).map((item, idx) => (
              <tr key={idx}>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.docNumber} onChange={(e) => handleChangeTable(idx, "docNumber", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.docDate} onChange={(e) => handleChangeTable(idx, "docDate", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTable} value={item.description} onChange={(e) => handleChangeTable(idx, "description", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.offsetAccount} onChange={(e) => handleChangeTable(idx, "offsetAccount", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.unitPrice} onChange={(e) => handleChangeTable(idx, "unitPrice", e.target.value)} /></td>
                
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.inwardQuantity} onChange={(e) => handleChangeTable(idx, "inwardQuantity", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.inwardAmount} onChange={(e) => handleChangeTable(idx, "inwardAmount", e.target.value)} /></td>
                
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.outwardQuantity} onChange={(e) => handleChangeTable(idx, "outwardQuantity", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.outwardAmount} onChange={(e) => handleChangeTable(idx, "outwardAmount", e.target.value)} /></td>
                
                <td style={{ ...s.td, backgroundColor: "#fdfdfd" }}><input disabled style={{ ...s.inputTableRight, fontWeight: "bold" }} value={fmt(item.balanceQuantity)} /></td>
                <td style={{ ...s.td, backgroundColor: "#fdfdfd" }}><input disabled style={{ ...s.inputTableRight, fontWeight: "bold" }} value={fmt(item.balanceAmount)} /></td>
                
                <td style={s.td}><input disabled={containView} style={s.inputTable} value={item.note} onChange={(e) => handleChangeTable(idx, "note", e.target.value)} /></td>
                {!containView && <td style={{ ...s.td, textAlign: "center" }}><button type="button" style={s.removeBtn} onClick={() => removeRow(idx)}>–</button></td>}
              </tr>
            ))}
            
            {/* DÒNG TỔNG CỘNG */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#fafafa" }}>
              <td style={s.td} colSpan={2}></td>
              <td style={{ ...s.td, textAlign: "center" }} colSpan={2}>Cộng tháng</td>
              <td style={{ ...s.td, textAlign: "center" }}>X</td>
              <td style={s.td}></td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>
                {fmt(details.reduce((acc, row) => acc + (parseFloat(row.inwardAmount) || 0), 0))}
              </td>
              <td style={s.td}></td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>
                {fmt(details.reduce((acc, row) => acc + (parseFloat(row.outwardAmount) || 0), 0))}
              </td>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={s.td}></td>
              {!containView && <td style={s.td}></td>}
            </tr>
          </tbody>
        </table>
        {!containView && (
          <SoftBox textAlign="center" mb={2}>
            <SoftButton variant="outlined" color="dark" size="small" onClick={addRow}>+ Thêm nghiệp vụ</SoftButton>
          </SoftBox>
        )}
      </div>

      {/* FOOTER: INFO */}
      <div style={{ marginTop: "15px" }}>
        <div style={s.rowLabel}>- Sổ này có <input disabled={containView} style={s.inputDottedSmall} value={values.totalPages} onChange={(e) => handleChangeField("totalPages", e.target.value)} /> trang, đánh số từ trang 01 đến trang...</div>
        <div style={s.rowLabel}>- Ngày mở sổ: <input disabled={containView} style={{ ...s.inputDotted, width: "150px" }} value={values.openingDate} onChange={(e) => handleChangeField("openingDate", e.target.value)} /></div>
      </div>

      {/* FOOTER: SIGNATURES */}
      {/* <div style={{ display: "flex", justifyContent: "space-between", marginTop: "30px", textAlign: "center" }}>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Người ghi sổ</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên)</div>
          <SoftBox mt={8}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.ledgerClerk} onChange={(e) => handleChangeField("ledgerClerk", e.target.value)} />
          </SoftBox>
        </div>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Kế toán trưởng</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên)</div>
          <SoftBox mt={8}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.chiefAccountant} onChange={(e) => handleChangeField("chiefAccountant", e.target.value)} />
          </SoftBox>
        </div>
        <div style={{ width: "40%" }}>
          <div style={{ fontStyle: "italic", fontSize: "14px", marginBottom: "5px" }}>
            Ngày <input disabled={containView} style={s.inputDottedSmall} value={values.signingDay} onChange={(e) => handleChangeField("signingDay", e.target.value)} /> tháng <input disabled={containView} style={s.inputDottedSmall} value={values.signingMonth} onChange={(e) => handleChangeField("signingMonth", e.target.value)} /> năm <input disabled={containView} style={{ ...s.inputDottedSmall, width: "50px" }} value={values.signingYear} onChange={(e) => handleChangeField("signingYear", e.target.value)} />
          </div>
          <div style={{ fontWeight: "bold" }}>Người đại diện theo pháp luật</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên, đóng dấu)</div>
          <SoftBox mt={8}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "200px", textAlign: "center" }} value={values.legalRepresentative} onChange={(e) => handleChangeField("legalRepresentative", e.target.value)} />
          </SoftBox>
        </div>
      </div> */}
    </SoftBox>
  );
}
